import React, { useState } from 'react'
import PakageCommunity from '../components/PakageCommunity/PakageCommunity'

const PakageCommunityPage = () => {
  return (
    <>
      <PakageCommunity />
    </>
  )
}

export default PakageCommunityPage
